<template>
	<div class="cmui-mask-panel fixed-full"
	@click="hide()"
	@touchstart="maskStart($event)"
	@touchmove="maskMove($event)"
	@touchend="maskEnd($event)"
	transition="maskPanel"
	v-show="show"
	>
		<div class="cmui-mask-panel_wrap abs-full flex-container" :class="position_c" >
			<div class="cmui-mask-panel_content flex-container-col" :style="{width:width_c,height:height_c}" @click.stop>
				<div class="cmui-mask-panel_top">
					<slot name="top"></slot>
				</div>
				<div class="cmui-mask-panel_main flex1 scroll-container-y">
					<slot></slot>
				</div>
				<div class="cmui-mask-panel_bottom">
					<slot name="bottom"></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
.cmui-mask-panel{
	background-color: rgba(0,0,0,.5);
	z-index: 98;
	webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	-ms-transform: translateZ(0);
	-o-transform: translateZ(0);
	transform: translateZ(0);
}
.cmui-mask-panel_wrap{}
.cmui-mask-panel_content{
	background-color: white;
}
.cmui-mask-panel_top{width: 100%;}
.cmui-mask-panel_main{width: 100%;overflow-y: scroll;-webkit-overflow-scrolling: touch;}
.cmui-mask-panel_bottom	{width: 100%;}
</style>
<script>
	let warpDom;
	let contentDom;
	let warpData={};
	let contentData={};
	let pos;
	let speedString;
	let prefix=(function(){
	    let div = document.createElement('div');  
	    let cssText = '-webkit-transition:all .1s; -moz-transition:all .1s; -o-transition:all .1s; -ms-transition:all .1s; transition:all .1s;';  
	    div.style.cssText = cssText;  
	    let style = div.style;  
	    if (style.webkitTransition) {  
	        return '-webkit-';  
	    }  
	    if (style.MozTransition) {  
	        return '-moz-';  
	    }  
	    if (style.oTransition) {  
	        return '-o-';  
	    }  
	    if (style.msTransition) {  
	        return '-ms-';  
	    }  
	    return '';  
	})()
	Vue.transition('maskPanel',{
		css:false,
		enter(el,done){
			let dis=100;
			let timer=requestAnimationFrame(function fn(){
				if(dis>0){
					dis-=6;
					el.style[prefix+'transform']=`translate${pos}(${speedString}${dis}%)`;
					requestAnimationFrame(fn);
				}else{
					cancelAnimationFrame(timer);
					el.style[prefix+'transform']=``;
					done();
				}
			})
		},
		enterCancelled(el){console.log('enterCancelled')},
		leave(el,done){
			let timer=requestAnimationFrame(function fn(){
				warpData.dis=warpData.dis||0;
				warpData.dis+=16;
				el.style[prefix+'transform']=`translate${pos}(${speedString}${warpData.dis}px)`;
				if(warpData.dis>document.body.clientWidth){
					cancelAnimationFrame(timer);
					warpData={};
					done()
					el.style[prefix+'transform']='';
				}else{
					requestAnimationFrame(fn);
				}
			})
		},
		leaveCancelled(el){console.log('leaveCancelled')}
	})
	export default{
		props:{
			position:{type:String,default:'right'},
			width:{type:String,default:''},
			height:{type:String,default:''},
			show:{type:Boolean,default:false}
		},
		ready(){
			warpDom=$(this.$el).find('.cmui-mask-panel_wrap')[0];
			contentDom=$(this.$el).find('.cmui-mask-panel_main')[0];
			pos=/left|right/.test(this.position_c)?'X':'Y';
			speedString=/right|bottom/.test(this.position_c)?'':'-';
		},
		computed:{
			position_c(){
				return _.compact(this.position.split(' ')).filter(item=>
					_.includes(['top','left','right','bottom','center'],item)
				).join(' ')
			},
			width_c(){
				if(this.width&&_.isString(this.width)){
					return this.width;
				}else{
					return _.includes(['bottom','top'],this.position_c)
					?'100%'
					:'80%'
				}
			},
			height_c(){
				if(this.height&&_.isString(this.height)){
					return this.height;
				}else{
					return _.includes(['bottom','top','center'],this.position_c)
					?'60%'
					:'100%'
				}
			}
		},
		methods:{
			hide(){
				this.show=false;
			},
			maskStart(e){
				let target=e.target;
				if(target===warpDom){
					warpData.startPosition=e.touches["0"][`page${pos}`]
				}else{
					let elScroll;
					if(target===contentDom){
						elScroll=$(target)
					}else if($(target).parents($(contentDom)).length !== 0){
						elScroll=$(contentDom)
					}else{
						elScroll = null;
					}
					if (!elScroll) {
					    return;
					}
					contentData.elScroll = elScroll;
					contentData.posY = e.touches["0"].pageY;
					contentData.scrollY = elScroll.scrollTop();
					contentData.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;
				}
			},
			maskMove(e){
				if(e.target===warpDom){
					let dis=e.touches["0"][`page${pos}`]-warpData.startPosition;
					if(dis*(speedString+'1')>0){
						this.$el.style[prefix+'transform']=`translate${pos}(${dis}px)`;
						warpData.dis=Math.abs(dis);
					}
					e.preventDefault();
				}else{
					if (contentData.maxscroll <= 0) {
					    e.preventDefault();
					}
					let elScroll = contentData.elScroll;
					let scrollTop = elScroll.scrollTop();
					let events = e.touches["0"];
					let distanceY = events.pageY - contentData.posY;
					if (distanceY > 0 && scrollTop == 0) {
					    e.preventDefault();
					    return;
					}
					if (distanceY < 0 && (scrollTop + 1 >= contentData.maxscroll)) {
					    e.preventDefault();
					    return;
					}
				}
			},
			maskEnd(e){
				if(e.target===warpDom){
					let _this=this;
					let needHide=warpData.dis>document.body.clientWidth/2;
					if(needHide){
						this.hide();
					}else{
						let timer=requestAnimationFrame(function fn(){
							warpData.dis-=8;
							_this.$el.style[prefix+'transform']=`translate${pos}(${speedString}${warpData.dis}px)`;
							if(warpData.dis>0){
								requestAnimationFrame(fn)
							}else{
								_this.$el.style[prefix+'transform']=''
								cancelAnimationFrame(timer);
							}
						})
					}
				}else{
					contentData.maxscroll = 0;
				}
			}
		}
	}
</script>